export function excludeKeys<T, TKey extends keyof T, TR extends Omit<T, TKey>>(object: T, ...keys: TKey[]) {
    const objectCopy = { ...object };
    keys.forEach(k => (delete objectCopy[k]));
    return objectCopy as unknown as TR;
}

export function getKeyByValue<T extends { [key: string]: any }>(obj: T, value: any) {
    return Object.keys(obj).find(key => (obj as any)[key] === value) as keyof typeof obj | undefined;
}
